var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonpayLightIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2570,
    height: 1337,
    viewBox: "0 0 2570 1337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_16013)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2570,
    height: 1337,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 1109C1310.11 1109 1842 577.114 1842 -79C1842 -735.114 1310.11 -1267 654 -1267C-2.11426 -1267 -534 -735.114 -534 -79C-534 577.114 -2.11426 1109 654 1109Z",
    fill: "url(#paint0_linear_713_16013)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_16013",
    x1: -179.5,
    y1: -571,
    x2: 1510,
    y2: 720.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9733FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D00FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_16013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2570,
    height: 1337,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonpayLightIllustration);
export default __webpack_public_path__ + "static/media/moonpay-light-illustration.141086d4e20d95b2da9656b0ae04f2c6.svg";
export { ForwardRef as ReactComponent };